import React, { FunctionComponent } from 'react';
import type { RecruitmentShowBottomItemThirdProps } from './types';
import type { Recruitment } from '../../../types/recruitmentShow';

type Props = & RecruitmentShowBottomItemThirdProps & {
  applications: Recruitment[];
};

export const Presentation: FunctionComponent<Props> = ({
  title,
  recruitmentId,
  noimage,
  isStopped,
  dataCategory,
  dataValue,
  applications,
  isPreview
}) => {
  if (applications.length === 0) return null

  return (
    <div className="recruitment__show__bottom__wrapper__content">
      <h2 className="mainTitle">{title}</h2>
      <div className="recruitment__show__applications__slider js-recruitment-bottom-third">
        {applications.map((application) => (
          <a
            key={application.id}
            href={`/recruitments/${application.id}`}
            className={`box ${!isPreview ? 'gtm-recruitment-view-count' : ''}`}
            target="_blank"
            rel="noopener noreferrer"
            {...(!isPreview && {
              'data-event-name': 'recruitments on screen',
              'data-event': 'click',
              'data-category': isStopped
                ? dataCategory.stopRecruitmentContent
                : dataCategory.recruitmentContent,
              'data-value': dataValue.recruitmentHistories,
              'data-recruitmentid': application.id,
              'data-companyid': application.companyId
            })}
          >
            {application.image.url ? (
              <img src={application.image.url} alt={`${application.title}の画像`} />
            ) : (
              <img src={noimage} alt={`${application.title}の画像`} />
            )}
            <p className="title">
              <span className="occupation">{application.title}</span>
              <span className="prefecture">{application.prefecture}</span>
            </p>
            <p className="body">{application.body}</p>
            <div className="bottomBox">
              {application.icon ? (
                <img src={application.icon} alt={`${application.title}の画像`} className="icon" />
              ) : (
                <img src={noimage} alt={`${application.title}の画像`} className="icon" />
              )}
              <p className="companyName">{application.companyName}</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};
